module.exports = {"bewizr-agenda":{"empty":{"title":"Καμία δραστηριότητα","detail":"Δεν έχετε προγραμματισμένες δραστηριότητες."}}}